import React, {useEffect, useState} from 'react';
import { useFetch } from "../../../../components/common/FetchProvider";

import CategoryModal from "./CategoryModal";
import FunctionsModal from "./FunctionsModal";
import {columnsDataEmployees} from "../variables/columnsData";
import CommonTable from "./CommonTable";

function EmployeesTable() {
  const fetchWrapper = useFetch();
  const [loading, setLoading] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [error, setError] = useState(false);
  const [showOrganModal, setShowOrganModal] = useState(false);
  const [showFunctionsModal, setShowFunctionsModal] = useState(false);
  const [employeesData, setEmployeesData] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      let apiUrl = `${process.env.REACT_APP_API_URL}/v1/configuration/employee`;

      const userToken = localStorage.getItem("token");
      const response = await fetchWrapper(apiUrl, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });
      setLoading(false);
      if (response.ok) {
        const responseData = await response.json();
        if (responseData.data && responseData.data.length > 0) {
          setApiData(responseData.data);
        } else {
          setError(true);
        }
      } else {
        setError(true);
        console.error('Error fetching API data:', response.status);
      }
    } catch (error) {
      setLoading(false);
      setError(true);
      console.error('Error fetching API data:', error);
    }
  };

  const mappedApiData = apiData.map((item) => ({
    id: item.id,
    name: item.name,
    categoryId: item.categoryValue,
    status: item.status,
    action: "Action"
  }));

  const handleOrganLinkClick = () => {
    setShowOrganModal(true);
    setShowFunctionsModal(false); // Close other modal if open
  };

  const handleFunctionsLinkClick = () => {
    setShowFunctionsModal(true);
    setShowOrganModal(false); // Close other modal if open
  };

  const refreshData = () => {
    reload();
  }

  const reload = () => {
    setEmployeesData(null);
    setApiData([]);
    fetchData();
  };

  const handleActionClick = (rowData) => {
    let data = apiData.find((item) => item.id === rowData.id);
    setEmployeesData(data);
    handleOrganLinkClick();
  };

  return (
      <div className="10">
        <header className="relative flex items-center justify-between">
          <div className="text-xl font-bold text-navy-700 dark:text-white">
            Funcionários
          </div>
          {/* Links with Separator */}
          <div className="flex justify-center items-center font-bold text-brand-600">
            <div>
              <div>
                <button onClick={handleOrganLinkClick}>Funcionário</button>
                {/* Conditional rendering of Organ Modal */}
                {showOrganModal && (
                    <FunctionsModal
                        showModal={showOrganModal}
                        setModalState={setShowOrganModal}
                        refreshData={refreshData}
                        employeesData={employeesData}
                        setEmployeesData={setEmployeesData}
                    />
                )}

                <span className="mx-2">|</span>
                <button onClick={handleFunctionsLinkClick}>Categoria</button>
                {/* Conditional rendering of Functions Modal */}
                {showFunctionsModal && (
                    <CategoryModal
                        showModal={showFunctionsModal}
                        setModalState={setShowFunctionsModal}
                        refreshData={refreshData}
                    />
                )}
              </div>
            </div>

          </div>

        </header>

        <div className="mt-1">
          {loading ? (
              <div></div>
          ) : apiData && apiData.length > 0 ? (
              <CommonTable
                  columnsData={columnsDataEmployees}
                  tableData={mappedApiData}
                  onActionClick={handleActionClick}
              />
          ) : (
              <></>
          )}
        </div>

      </div>
  );
}

export default EmployeesTable;
